import { render, staticRenderFns } from "./quillTextEditor.vue?vue&type=template&id=a96ac48e&"
import script from "./quillTextEditor.vue?vue&type=script&lang=js&"
export * from "./quillTextEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports